module.exports = __webpack_public_path__ + "img/add-point-icon.4f1b2b6b.svg";